var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6313 16.5437C11.6313 17.85 10.95 19.9875 9.3375 19.9875C7.725 19.9875 7.04375 17.85 7.04375 16.5437C7.04375 15.2375 7.725 13.1 9.3375 13.1C10.95 13.1 11.6313 15.2375 11.6313 16.5437ZM30 13.3875C30 15.3812 29.8 17.4937 28.9062 19.325C26.5375 24.1125 20.025 24 15.3625 24C10.625 24 3.725 24.1687 1.2625 19.325C0.35 17.5125 0 15.3812 0 13.3875C0 10.7688 0.86875 8.29375 2.59375 6.2875C2.26875 5.3 2.1125 4.2625 2.1125 3.2375C2.1125 1.89375 2.41875 1.21875 3.025 0C5.85625 0 7.66875 0.5625 9.825 2.25C11.6375 1.81875 13.5 1.625 15.3687 1.625C17.0562 1.625 18.7562 1.80625 20.3937 2.2C22.5187 0.53125 24.3313 0 27.1313 0C27.7437 1.21875 28.0438 1.89375 28.0438 3.2375C28.0438 4.2625 27.8813 5.28125 27.5625 6.25C29.2812 8.275 30 10.7688 30 13.3875ZM25.9813 16.5437C25.9813 13.8 24.3125 11.3812 21.3875 11.3812C20.2063 11.3812 19.075 11.5938 17.8875 11.7562C16.9563 11.9 16.025 11.9562 15.0688 11.9562C14.1188 11.9562 13.1875 11.9 12.25 11.7562C11.0813 11.5938 9.9375 11.3812 8.75 11.3812C5.825 11.3812 4.15625 13.8 4.15625 16.5437C4.15625 22.0312 9.18125 22.875 13.5562 22.875H16.5688C20.9625 22.875 25.9813 22.0375 25.9813 16.5437ZM20.8188 13.1C19.2063 13.1 18.525 15.2375 18.525 16.5437C18.525 17.85 19.2063 19.9875 20.8188 19.9875C22.4312 19.9875 23.1125 17.85 23.1125 16.5437C23.1125 15.2375 22.4312 13.1 20.8188 13.1Z",
    fill: "url(#paint0_linear_78_57)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_57",
    x1: 31.4318,
    y1: 24.0007,
    x2: -1.5056,
    y2: 23.4293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455446,
    stopColor: "#02F781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FFF00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.bf4e5fc9395702524cb0138ab2804162.svg";
export { ForwardRef as ReactComponent };